import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, RefreshCw, MessageCircle } from 'lucide-react';

const PaymentFailure: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4 relative overflow-hidden">
            {/* Background Elements */}
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-900/20 via-[#050505] to-[#050505]" />
            <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-red-500/20 to-transparent" />
            <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-red-500/20 to-transparent" />

            <motion.div
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="relative z-10 max-w-md w-full bg-[#101012] border border-white/10 rounded-2xl p-8 shadow-2xl overflow-hidden"
            >
                {/* Glow Effect */}
                <div className="absolute -top-[100px] left-1/2 transform -translate-x-1/2 w-[200px] h-[200px] bg-red-500/20 blur-[60px] rounded-full pointer-events-none" />

                <div className="text-center relative z-10">
                    <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ type: 'spring', duration: 0.6, delay: 0.2 }}
                        className="inline-flex items-center justify-center w-24 h-24 bg-red-500/10 rounded-full mb-6 border border-red-500/30"
                    >
                        <XCircle className="w-12 h-12 text-red-400" />
                    </motion.div>

                    <h1 className="text-3xl font-bold text-white mb-2">Payment Failed</h1>
                    <p className="text-zinc-400 mb-8">
                        We couldn't process your payment. Please check your card details or try again with a different payment method.
                    </p>

                    <div className="space-y-4">
                        <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={() => navigate('/dashboard')}
                            className="w-full py-4 bg-white/5 border border-white/10 hover:bg-white/10 text-white rounded-xl font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2"
                        >
                            <RefreshCw className="w-5 h-5" />
                            Try Again
                        </motion.button>

                        <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={() => window.open('mailto:support@futurasmile.com')}
                            className="w-full py-4 bg-transparent text-zinc-400 hover:text-white rounded-xl font-medium text-sm transition-all duration-300 flex items-center justify-center gap-2"
                        >
                            <MessageCircle className="w-4 h-4" />
                            Contact Support
                        </motion.button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default PaymentFailure;
